/****************************************************
 * Module Name:  reportSalesProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class SalesProxy {
  static GetAllInvoiceReport = (userid, userType, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/report/sales/${userid}/${userType}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllProformaReport = (userid, userType, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/report/performa/customer/${userid}/${userType}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static PayInvoiceAmount = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/amounttopaid`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllProforma = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/report/performa/customer/open`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllProformaByStoneid = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/report/performa/customer/open/bystoneid`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteProforma = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/performa`,
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetCustomersCreatedInvoice = (locationid, userid, usertype, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/report/invoice/customers/${locationid}/${userid}/${usertype}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetCustomersCreatedProforma = (locationid, userid, usertype, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/report/proforma/customers/${locationid}/${userid}/${usertype}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
